import React from 'react';

const DayWeek = (props) => {
  const { day, langDay } = props.data;
  const date = new Date(day);

  const dayOfWeek = langDay[date.getDay()];
  return <p className="day-week">{dayOfWeek}</p>;
};

export default DayWeek;
